import ReturnInspectionWizardPage from "../ReturnInspectionWizardPage";
import React, { ReactNode } from "react";
import {
  IReturnedMassProductPageProps,
  IReturnedMassProductPageState
} from "@/pages/ReturnedMassProductPage/ReturnedMassProductPage.types";
import {ReturnedMassProductStep} from "./components";

export default class ReturnedMassProductPage extends ReturnInspectionWizardPage<IReturnedMassProductPageProps, IReturnedMassProductPageState> {
    state = {
        deviceTelematics: null,
        additionalExpenses: [],
    };

    public renderContent(): ReactNode {
        return (
            <ReturnedMassProductStep index={this.currentIndex}
                                     preview={this.preview}
            />
        );
    }
}